import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import { setSelProdInfoAction } from '../../../modules/common/prodModule';
import ProdItem from './ProdItem';
import { useHistory } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';

const ProdItemListBlock = styled.div`
`;

const ProdItemListUlBlock = styled.ul`
/*JP*/
    display: flex;
    flex-wrap: wrap;
    justify-content: ${isMobileOnly?'space-between':'flex-start'};
/*JP*/    
    ${isMobileOnly?"margin-left:0":"margin-left: -28px"};
    margin-bottom: 80px;

    ::-webkit-scrollbar {
        width: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }

    ::-webkit-scrollbar-track {
        background-color: #f4f4f4;
    }

    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const ProdItemNoItemBloc = styled.div`
    position: relative;
    height: 180px;
`;

const ProdItemNoItemSpanBlock = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    color: #666;
    font-size: 16px;
`;

const ProdItemList = ({ prodItems }) => {
    const dispatch = useDispatch();
    const history = useHistory();

    // Redux Store에서 저장된 값을 가져옴
    var { curMenu } = useSelector(
        ({ headerReducer }) => ({
            curMenu: headerReducer.curMenu,
            headerTransparent: headerReducer.headerTransparent
        })
    );

    const [curProdItem, setCurProdItem] = useState(null);

    if (prodItems === null || prodItems === undefined) {
        return <ProdItemListBlock />
    }

    const isNull = (value) => {
        return value !== null;
    }

    const handleImgClick = (prodinfo) => {
        // console.log("handleImgClick ====>" + JSON.stringify(prodinfo._source))
        // 썸네일 이미지 만들기
        let thumbnailimg = [];
        thumbnailimg.push(prodinfo._source.repr_img);
        thumbnailimg.push(prodinfo._source.opt_img_1);
        thumbnailimg.push(prodinfo._source.opt_img_2);
        thumbnailimg.push(prodinfo._source.opt_img_3);
        thumbnailimg.push(prodinfo._source.opt_img_4);
        thumbnailimg.push(prodinfo._source.opt_img_5);
        thumbnailimg.push(prodinfo._source.opt_img_6);
        thumbnailimg.push(prodinfo._source.opt_img_7);
        thumbnailimg.push(prodinfo._source.opt_img_8);
        thumbnailimg.push(prodinfo._source.opt_img_9);
        prodinfo._source.thumbnails = thumbnailimg.filter(isNull);
        dispatch(setSelProdInfoAction(prodinfo._source));
        setCurProdItem(prodinfo._source);
        history.push('/prod?prodid=' + prodinfo._source.prdct_id)
    }

    if (prodItems !== null && prodItems.dataList === undefined && prodItems.paging) {
        return (<ProdItemListBlock>
            <ProdItemNoItemBloc>
                <ProdItemNoItemSpanBlock>
                    상품이 없습니다.
                        </ProdItemNoItemSpanBlock>
            </ProdItemNoItemBloc>
        </ProdItemListBlock>);
    }

    if (prodItems === null || prodItems.dataList === null
        || prodItems.dataList === undefined || prodItems === undefined) {
        return <ProdItemListBlock />
    }

    return (
        <ProdItemListBlock>
            <ProdItemListUlBlock>
                {
                    // 상품 리스트 표시
                    prodItems.dataList.map((proditem) => {
                        return (
                            <ProdItem key={proditem._source.prdct_id}
                                img={proditem._source.repr_img}
                                prodname={proditem._source.prdct_nm}
                                sale_price={proditem._source.sale_price}
                                prdct_price={proditem._source.prdct_price}
                                brandname={proditem._source.brnd_han}
                                isBrandShow={curMenu === 'ct'}
                                clickHandler={handleImgClick}
                                brandid={proditem._source.brnd_id}
                                prodinfo={proditem} />
                        )
                    }
                    )
                }
            </ProdItemListUlBlock>
        </ProdItemListBlock >
    );
};

export default ProdItemList;
